import styled from 'styled-components';
import ScreenSize from '../../../config/screenSizes.json';

export const ButtonCampaign = styled.button`
	& {
		text-align: center;
		width: ${({ width }) => (width || '203px')};
		font-family: Poppins, Heltica, Arial, sans-serif;
		border-radius:  ${({ borderRadius }) => (borderRadius || '4px')};;
		background-color: transparent;
		color: ${({ color }) => (color || '#00BDCE')};
		font-size: ${({ fontSize }) => (fontSize || '14px')};
		line-height:  ${({ lineHeight }) => (lineHeight || '21px')};;
        padding: ${({ padding }) => (padding || '9px 11px')};
		border: ${({ border }) => (border || '1px solid #00BDCE')};
		transition: all .3s ease-in-out;
		float: right;
		letter-spacing: 0px;
		margin-top: 2px;
		margin-right:  ${({ marginRight }) => (marginRight || '20px')};
	}
	
	&:focus {
		outline: 0;
	}

    @media screen and (max-width: ${ScreenSize.portrait}px) {
    & {
        max-width: 140px;
        padding: 10px;
        font-size: 12px;
    }
}
`;
